import React from "react";
import "./AimAndScope.css";

export default function AimAndScope() {
  return (
    <section className="aimscope-section">
      <div className="aimscope-header">
        <h1 className="aimscope-title">Aim & Scope</h1>
        <p className="aimscope-subtitle">
          International Journal of Advanced Communication and Network
          Applications (IJACNA)
        </p>
      </div>

      <div className="aimscope-content">
        <p>
          The{" "}
          <strong>
            International Journal of Advanced Communication and Network
            Applications (IJACNA)
          </strong>
          aims to provide a platform for academicians, researchers, and scholars
          to share their original and high-quality research work across various
          disciplines. The journal encourages cross-disciplinary studies and
          promotes the exchange of ideas among professionals in science,
          engineering, technology, management, arts, and social sciences.
        </p>

        <h2 className="aimscope-heading">Our Objectives</h2>
        <ul className="aimscope-list">
          <li>
            To promote research activities and the dissemination of knowledge
            across diverse disciplines.
          </li>
          <li>
            To provide a medium for researchers and academicians to publish
            their innovative work and findings.
          </li>
          <li>
            To encourage collaboration among researchers, educators, and
            practitioners globally.
          </li>
          <li>
            To ensure high-quality publications through rigorous peer review.
          </li>
        </ul>

        <h2 className="aimscope-heading">Scope of the Journal</h2>
        <p>
          IJACNA welcomes contributions in the latest research domains related to communication, networking, and advanced computational technologies:
        </p>
        <div className="aimscope-grid"> <div className="aimscope-card">Computer Networks & Network Architectures</div> <div className="aimscope-card">5G MIMO & Massive MIMO Technologies</div> <div className="aimscope-card">Network Security & Cyber Security</div> <div className="aimscope-card">Optical & Underwater Optical Communication</div> <div className="aimscope-card">Wireless Communication & IoT Networks</div> <div className="aimscope-card">Cryptography & Secure Communication Protocols</div> <div className="aimscope-card">Cloud Computing & Distributed Systems</div> <div className="aimscope-card">Mobile Adhoc Networks (MANETs)</div> <div className="aimscope-card">Vehicular Adhoc Networks (VANETs)</div> <div className="aimscope-card">Communication Systems & Signal Processing</div> <div className="aimscope-card">Communication Engineering</div> <div className="aimscope-card">Computer Engineering</div> <div className="aimscope-card">Computer Science & Engineering</div> </div>

        <p className="aimscope-footer-text">
          IJACNA encourages the submission of original research papers, review articles, case studies, and technical notes that enhance the understanding and development of advanced communication systems, secure networks, and futuristic engineering technologies.
        </p>
      </div>
    </section>
  );
}
